import { Box, Typography } from "@mui/material";
import details from '../../../../../data/details.json';

export default function MobileContactPage(){

    return(
       <Box 
            sx={{
                mt:7,
                justifyContent:'center',
                alignItems:'center'
            }}
            display="flex"
            flexDirection="column"
            alignItems="center"
       >
            <Typography>{details.address}</Typography>
            <iframe
                title="mobilelocationgooglemaps" 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2226.5639420230314!2d24.006134221236756!3d37.88750232385716!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14a18ef944668e7d%3A0x98183b7915aa7481!2sApostolis!5e0!3m2!1sen!2sgr!4v1754335194003!5m2!1sen!2sgr" 
                width="300" 
                height="300" 
                style={{border:0}} 
                allowfullscreen="" 
                loading="lazy" 
                referrerpolicy="no-referrer-when-downgrade">
            </iframe>
            <Box
                width={'300px'}
            >
                <Typography>Ώρες λειτουργείας:</Typography>
                <Typography>Καθημερινές, 17:00 το απόγευμα - 1:00 το βράδυ</Typography>
                <Typography>Σάββατο & Κυριακή, 13:00 το μεσημέρι - 1:00 το βράδυ</Typography>
            </Box>
       </Box>
       );
}